"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppThunkDispatch = exports.store = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var react_redux_1 = require("react-redux");
var loginSlice_1 = __importDefault(require("../features/login/loginSlice"));
var userSlice_1 = __importDefault(require("../features/user/userSlice"));
var postSlice_1 = __importDefault(require("../features/post/postSlice"));
var promotedPostSlice_1 = __importDefault(require("../features/promotedPost/promotedPostSlice"));
var languageSlice_1 = __importDefault(require("../features/languages/languageSlice"));
var currencySlice_1 = __importDefault(require("../features/currencies/currencySlice"));
var mapSlice_1 = __importDefault(require("../features/google/mapSlice"));
var paginationSlice_1 = __importDefault(require("../features/pagination/paginationSlice"));
var registerSlice_1 = __importDefault(require("../features/register/registerSlice"));
var subscriptionSlice_1 = __importDefault(require("../features/subscription/subscriptionSlice"));
var searchParamsSlice_1 = __importDefault(require("../features/searchParams/searchParamsSlice"));
var searchResultSlice_1 = __importDefault(require("../features/SearchResult/searchResultSlice"));
var settingsSlice_1 = __importDefault(require("../features/settings/settingsSlice"));
var globalSlice_1 = __importDefault(require("../features/global/globalSlice"));
var myAnnouncementsSlice_1 = __importDefault(require("../features/myAnnouncements/myAnnouncementsSlice"));
var wishListSlice_1 = __importDefault(require("../features/wishList/wishListSlice"));
var smsVerifySlice_1 = __importDefault(require("../features/smsVerify/smsVerifySlice"));
var statisticsSlice_1 = __importDefault(require("../features/statistics/statisticsSlice"));
var developerSlice_1 = __importDefault(require("../features/developers/developerSlice"));
var newsletterSubscriptionSlice_1 = __importDefault(require("../features/newsletterSubscription/newsletterSubscriptionSlice"));
var contactUsSlice_1 = __importDefault(require("../features/contactUs/contactUsSlice"));
var schemaSlice_1 = __importDefault(require("../features/post/schemaSlice"));
var homeHeroSlidesSlice_1 = __importDefault(require("../features/homeHeroSlides/homeHeroSlidesSlice"));
var homeListingsSlice_1 = __importDefault(require("../features/homeListings/homeListingsSlice"));
exports.store = toolkit_1.configureStore({
    reducer: {
        login: loginSlice_1.default,
        user: userSlice_1.default,
        post: postSlice_1.default,
        languages: languageSlice_1.default,
        currencies: currencySlice_1.default,
        registration: registerSlice_1.default,
        map: mapSlice_1.default,
        pagination: paginationSlice_1.default,
        searchParams: searchParamsSlice_1.default,
        subscription: subscriptionSlice_1.default,
        global: globalSlice_1.default,
        searchResult: searchResultSlice_1.default,
        settings: settingsSlice_1.default,
        wishList: wishListSlice_1.default,
        myAnnouncements: myAnnouncementsSlice_1.default,
        smsVerify: smsVerifySlice_1.default,
        statistics: statisticsSlice_1.default,
        developer: developerSlice_1.default,
        newsletterSubscription: newsletterSubscriptionSlice_1.default,
        contactUs: contactUsSlice_1.default,
        promotedPost: promotedPostSlice_1.default,
        schema: schemaSlice_1.default,
        homeHeroSlides: homeHeroSlidesSlice_1.default,
        homeListings: homeListingsSlice_1.default,
    },
});
var useAppThunkDispatch = function () { return react_redux_1.useDispatch(); };
exports.useAppThunkDispatch = useAppThunkDispatch;
